import { Link } from "react-router-dom";
import { SITE } from "../lib/site";
import CookiePreferencesButton from "./CookiePreferencesButton";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      translate="no"
      lang="it"
      className="notranslate bg-[var(--ee-ink)] text-[var(--ee-ivory)]/70 border-t border-white/10"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-12 grid sm:grid-cols-3 gap-8">
        <div>
          <div className="font-serif-display italic text-[28px] text-[var(--ee-ivory)] leading-none">
            elite
          </div>
          <div className="mt-2 text-[10px] uppercase tracking-[0.28em] text-[var(--ee-rose)]">
            Estetica · Bellezza · Solarium
          </div>
          <p className="mt-5 text-[13px] leading-[1.7] max-w-xs">
            Centro estetico a Venezia Mestre. Bellezza, benessere e solarium dal
            2015.
          </p>
        </div>
        <div>
          <div className="text-[11px] uppercase tracking-[0.22em] text-[var(--ee-ivory)]/50">
            Contatti
          </div>
          <ul className="mt-4 space-y-2 text-[13.5px] text-[var(--ee-ivory)]/85">
            <li>Via Don Federico Tosatto 22</li>
            <li>30174 Venezia (Mestre)</li>
            <li>
              <a
                href={SITE.phoneTel}
                className="hover:text-[var(--ee-rose)] transition-colors"
              >
                {SITE.phone}
              </a>
            </li>
            <li>
              <a
                href="mailto:info@esteticaelite.eu"
                className="hover:text-[var(--ee-rose)] transition-colors"
              >
                info@esteticaelite.eu
              </a>
            </li>
          </ul>
        </div>
        <div>
          <div className="text-[11px] uppercase tracking-[0.22em] text-[var(--ee-ivory)]/50">
            Prenotazione
          </div>
          <ul className="mt-4 space-y-2 text-[13.5px] text-[var(--ee-ivory)]/85">
            <li>
              <Link
                to="/prenota"
                data-testid="footer-book-link"
                className="hover:text-[var(--ee-rose)] transition-colors"
              >
                Prenota online
              </Link>
            </li>
            <li>
              <a
                href={SITE.maps}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[var(--ee-rose)] transition-colors"
              >
                Indicazioni Google Maps
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Sezione legale */}
      <div className="ee-footer-legal">
        <div className="ee-footer-legal__row">
          <div>
            ELITE S.n.c. di Fanton Paola e Fontolan Erika · P.IVA 04277830271 ·
            Via Don Federico Tosatto 22, 30174 Venezia (Mestre)
          </div>
          <div className="ee-footer-legal__links">
            <Link to="/privacy-policy" className="ee-footer-legal__link">
              Privacy Policy
            </Link>
            <span className="ee-footer-legal__sep">·</span>
            <Link to="/cookie-policy" className="ee-footer-legal__link">
              Cookie Policy
            </Link>
            <span className="ee-footer-legal__sep">·</span>
            <CookiePreferencesButton className="ee-footer-legal__link" />
          </div>
          <div>
            © {new Date().getFullYear()} Estetica Elite - Tutti i diritti
            riservati
          </div>
        </div>
      </div>
    </footer>
  );
}
